import type { JSX } from 'react'

export const AngleUpIcon = (): JSX.Element => (
  <use href='#angleUpIcon' height='100%' width='100%' />
)
